export enum MAIL_APP_TYPE {
  PRACTICE_PROGRAM = 'Practice Program',
}
